<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Уведомления</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить уведомление</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="input_name_client_id">Клиент</label>
                <v-select
                    v-model="formData.client_id"
                    :items="clients"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <span>Данные не найдены</span>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="n-name">Заголовок уведомления <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="n-name" v-model="formData.name" placeholder="Введите заголовок">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="n-name">Текст уведомления</label>
                <textarea class="form-control" type="text" id="n-text" v-model="formData.text" placeholder="Введите текст уведомления"></textarea>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-6 mb-3">
                <label for="n-display_at" class="form-label">Дата начала показа</label>
                <input class="form-control" id="n-display_at" type="datetime-local" v-model="formData.display_at">
                <div class="valid-feedback">Успешно</div>
            </div>

            <div class="col-md-6">
                <label for="n-hide_at" class="form-label">Дата окончания показа</label>
                <input class="form-control" id="n-hide_at" type="datetime-local" v-model="formData.hide_at">
                <div class="valid-feedback">Ошибка</div>
            </div>
        </div>

        <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" value="" id="n-pinned" v-model="formData.pinned">
            <label class="form-check-label" for="n-pinned">Закрепить?</label>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createNotification"/>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Notification from "../../../../models/Notification";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "NotificationsCreateComponent",
    components: { ConfirmBtn },
    props: {
        route_back: String,
        route_client_search: String,
        route_create: String
    },
    data: function () {
        return {
            notification: new Notification({
                route_client_search: this.route_client_search,
                route_create: this.route_create
            }),
            clients: [],
            formData: {
                client_id: null,
                name: '',
                text: '',
                display_at: '',
                hide_at: '',
                pinned: ''
            }
        }
    },
    methods: {
        ...mapMutations('ui', ['toggleLoading']),
        createNotification: function () {
            let result = this.notification.create(this.formData);
            if(result)
            {
                window.location.href = this.route_back;
            }
            else
            {
                console.log('error: create_notification');
                this.toggleLoading();
            }
        },
        searchClients: async function () {
            let clients = await this.notification.clients();
            this.clients = clients.items;
        },
    },
    mounted() {
        this.searchClients();
    }
}
</script>

<style scoped>

</style>
